import { Location } from '@angular/common';
import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { filter, firstValueFrom, Subscription } from 'rxjs';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { GeneralParameters } from 'src/app/constants/general-parameters-constans';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { FormatsEnums } from 'src/app/enum/formats-enums';
import { InventoryEntryStateEnums, InventoryEntryTypeEnums } from 'src/app/enum/inventory-entry-enums';
import { TypeConceptEnums } from 'src/app/enum/type-concept-enums';
import { WindowEnums } from 'src/app/enum/window-enums';
import { OptionWindowModel } from 'src/app/models/authentication/option-window.model';
import { UserModel } from 'src/app/models/authentication/user.model';
import { FormatModel } from 'src/app/models/formats/format.model';
import { InventoryEntryModel } from 'src/app/models/inventory/inventory-entry.model';
import { BranchModel } from 'src/app/models/management/branch.model';
import { InventoryEntryPrintModel } from 'src/app/models/print/inventory/inventory-entry-print.model';
import { ProviderService } from 'src/app/services/archive/provider.service';
import { OptionWindowService } from 'src/app/services/authentication/option-window.service';
import { WindowService } from 'src/app/services/authentication/window.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { FormatService } from 'src/app/services/formats/format.service';
import { DateConverterService } from 'src/app/services/global-services/date-converter.service';
import { UserAuthenticatedService } from 'src/app/services/global-services/user-authenticated.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { InventoryEntryService } from 'src/app/services/inventory/inventory-entry.service';
import { InventoryService } from 'src/app/services/inventory/inventory.service';
import { BranchService } from 'src/app/services/management/branch.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';

@Component({
  selector: 'app-register-inventory-entry',
  templateUrl: './register-inventory-entry.component.html',
  styleUrls: ['./register-inventory-entry.component.scss'],
  standalone: false
})
export class RegisterInventoryEntryComponent implements OnInit, OnDestroy {

  branchId: number = 0;
  companyId: number = 0;
  disabledActions: boolean = true;
  disabledDetail: boolean = true;
  disabledForm: boolean = false;
  finishLoadingPrint: boolean = false;
  formInventoryEntry: FormGroup = new FormGroup({});
  formatModel: FormatModel = new FormatModel();
  mainBranchByUser: BranchModel = new BranchModel();
  iconState: string = "pi pi-lock-open";
  inventoryEntryContract: InventoryEntryModel = new InventoryEntryModel();
  inventoryEntryPrintModel: InventoryEntryPrintModel = new InventoryEntryPrintModel();
  inventoryId: number = 0;
  inventoryEntryId: number = 0;
  inventoryEntryTypeId: number = InventoryEntryTypeEnums.entry;
  isOpened: string | undefined = undefined;
  listBranches: any[] = [];
  listConcepts: any[] = [];
  listInventories: any[] = [];
  listProviders: any[] = [];
  listTypes: any[] = [];
  listObservers: Array<Subscription> = new Array<Subscription>();
  nameWindow: string = 'Captura Entradas de Inventario';
  titleState: string = "";
  permissionUpdatable: boolean = false;
  permissionsUser: OptionWindowModel[] = [];
  projectName = ProjectName.projectName;
  quantityDetails: number = 0;
  severityState: string = "danger";
  stateOpen: number = InventoryEntryStateEnums.open;
  swPurchaseModule: boolean = false;
  stateText: string = 'Abierta';
  url: string = "inventory-entry";
  userAuthenticated: UserModel = new UserModel();
  disabledState: boolean = false;
  typeConceptEntry: number = TypeConceptEnums.entrada;
  visibleState: boolean = false;

  constructor(
    private activatedRoute: ActivatedRoute,
    private branchService: BranchService,
    private dateConverterService: DateConverterService,
    private confirmDialogService: ConfirmDialogService,
    private formBuilder: FormBuilder,
    private formatService: FormatService,
    private headerService: HeaderService,
    private inventoryService: InventoryService,
    private inventoryEntryService: InventoryEntryService,
    private location: Location,
    private optionWindowService: OptionWindowService,
    private providerService: ProviderService,
    private title: Title,
    private toastHandlerService: ToastHandlerService,
    private userAuthenticatedService: UserAuthenticatedService,
    private windowService: WindowService) { }

  async ngOnInit() {
    this.headerService.setTitle(this.nameWindow);
    await this.validateForm(new InventoryEntryModel());
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    await this.getPermission();
    this.activatedRoute.params.subscribe(params => {
      this.inventoryEntryId = Object.keys(params).length > 0 ? params?.id : null;
    });
    await this.handleInitialState();
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  async ngOnDestroy() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      const window = windowsOpened.findIndex(x => x === this.url);
      if (window != -1) {
        windowsOpened.splice(window, 1);
        localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      }
    }

    this.listObservers.forEach(sub => sub.unsubscribe());
  }

  async changeConsecutive() {
    let consecutive = this.formInventoryEntry.get("consecutive")?.value;
    const inventoryId = this.formInventoryEntry.get("inventoryId")?.value;
    const branchId = this.formInventoryEntry.get("branchId")?.value;
    const inventoryEntryTypeId = this.formInventoryEntry.get("inventoryEntryTypeId")?.value;

    if (this.inventoryEntryContract.consecutive == consecutive) return;

    if (inventoryId == null || inventoryId == 0) {
      this.toastHandlerService.showToast(
        'warning',
        'Seleccione un inventario.'
      );
      return;
    } else if (branchId == null || branchId == 0) {
      this.toastHandlerService.showToast(
        'warning',
        'Seleccione una sucursal.'
      );
      return;
    }

    consecutive = consecutive === 0 ? null : consecutive;
    if (consecutive == null) {
      await this.resetInventoryEntry(inventoryId, branchId, inventoryEntryTypeId);
      return;
    }

    try {
      this.inventoryEntryContract = await firstValueFrom(
        this.inventoryEntryService.getInventoryEntryByKeysAsync(inventoryId, branchId, inventoryEntryTypeId, consecutive)
      );
      this.inventoryEntryId = this.inventoryEntryContract.inventoryEntryId;
      await this.validateForm(this.inventoryEntryContract);
      this.location.replaceState(`/${this.url}/register/${this.inventoryEntryId}`);
    } catch (error) {
      this.handleInventoryEntryNotFound(inventoryId, branchId, inventoryEntryTypeId, consecutive);
      console.error('Error al buscar la entrada de inventario por campos de recuperación.', error);
    }
  }

  changeSelection() {
    this.quantityDetails = 0;
    this.inventoryEntryId = 0;
    const modelInventoryEntry = new InventoryEntryModel();
    modelInventoryEntry.inventoryId = this.inventoryId;
    modelInventoryEntry.branchId = this.branchId;
    modelInventoryEntry.inventoryEntryTypeId = this.inventoryEntryTypeId;
    this.inventoryEntryContract = modelInventoryEntry;
    this.validateForm(modelInventoryEntry);

    this.location.replaceState(`/${this.url}/register`);
  }

  async changeState() {
    if (!this.validations()) return;
    try {
      this.inventoryEntryContract = await firstValueFrom(
        this.inventoryEntryService.setStateInventoryEntry(this.inventoryEntryContract.inventoryEntryId)
      );
      await this.validateForm(this.inventoryEntryContract);
      this.toastHandlerService.showToast(
        'success',
        'El estado de la entrada de inventario se modificó exitosamente.'
      );
    } catch (error) {
      console.error('Error al modificar el estado de la entrada de inventario.', error);
    }
  }

  changeValues() {
    this.disabledDetail = true;
    this.disabledState = true;
  }

  async createNewInventoryEntry() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast(
        'warning',
        'El usuario no tiene permisos para crear entradas de inventario. Comuníquese con el administrador del sistema'
      );
      return;
    }
    if (this.inventoryEntryTypeId == InventoryEntryTypeEnums.transfer) {
      this.toastHandlerService.showToast(
        'warning',
        'No está permitido crear entradas de tipo Traslado'
      );
      return;
    }

    this.quantityDetails = 0;
    this.inventoryEntryId = 0;
    this.inventoryEntryContract = new InventoryEntryModel();
    this.inventoryEntryContract.consecutive = 0;
    this.inventoryEntryContract.branchId = this.branchId;
    this.inventoryEntryContract.inventoryId = this.inventoryId;
    this.inventoryEntryContract.inventoryEntryTypeId = this.inventoryEntryTypeId;
    await this.validateForm(this.inventoryEntryContract);
    this.location.replaceState(`/${this.url}/register`);
  }

  async deleteInventoryEntry() {
    if (!this.validations()) return;

    if (this.quantityDetails > 0) {
      this.toastHandlerService.showToast(
        'warning',
        'No es posible eliminar, la entrada de inventario tiene detalle.');
      return;
    }

    const confirmed = await this.confirmDialogService.confirm(
      `¿Realmente desea eliminar la entrada de inventario ${this.inventoryEntryContract.consecutive}?`
    );
    if (confirmed) {
      try {
        await firstValueFrom(this.inventoryEntryService.deleteInventoryEntry(
          this.inventoryEntryContract.inventoryEntryId)
        );
        this.toastHandlerService.showToast(
          'success',
          'La entrada de inventario fue eliminada exitosamente.'
        );
        this.createNewInventoryEntry();
      } catch (error) {
        console.error('Error al eliminar la entrada de inventario.', error);
      }
    }
  }

  async editInventoryEntry() {
    await this.getInventoryEntryById();
    await this.validateForm(this.inventoryEntryContract);
    this.inventoryId = this.inventoryEntryContract.inventoryId;
    this.branchId = this.inventoryEntryContract.branchId;
    this.inventoryEntryTypeId = this.inventoryEntryContract.inventoryEntryTypeId;
  }

  finishLoading(finish: boolean) {
    this.finishLoadingPrint = finish;
  }

  async handleInitialState() {
    if (this.inventoryEntryId !== null && this.inventoryEntryId !== 0) {
      await this.editInventoryEntry();
    } else {
      await this.getFirstInventoryByCompanyAuthenticatedAsync();
      this.createNewInventoryEntry();
    }
  }

  handleInventoryEntryNotFound(inventoryId: number, branchId: number, inventoryEntryTypeId: number, consecutive: number): void {
    this.inventoryEntryContract = new InventoryEntryModel();
    this.inventoryEntryContract.inventoryEntryId = 0;
    this.inventoryEntryContract.inventoryId = inventoryId;
    this.inventoryEntryContract.branchId = branchId;
    this.inventoryEntryContract.inventoryEntryTypeId = inventoryEntryTypeId;
    this.inventoryEntryContract.inventoryEntryId = this.inventoryEntryId;
    this.inventoryEntryContract.consecutive = consecutive;
  }

  async handleInventoryEntryNavigation(buttonClick: any, inventoryId: number, branchId: number, inventoryEntryTypeId: number, consecutive: number | null) {
    const actionMap: Record<string, () => Promise<InventoryEntryModel>> = {
      first: async () =>
        await firstValueFrom(this.inventoryEntryService.getFirstInventoryEntryByKeysAsync(inventoryId, branchId, inventoryEntryTypeId)),
      previus: async () =>
        await firstValueFrom(this.inventoryEntryService.getPreviusInventoryEntryByKeysAsync(inventoryId, branchId, inventoryEntryTypeId, consecutive)),
      next: async () =>
        await firstValueFrom(this.inventoryEntryService.getNextInventoryEntryByKeysAsync(inventoryId, branchId, inventoryEntryTypeId, consecutive)),
      last: async () =>
        await firstValueFrom(this.inventoryEntryService.getLastInventoryEntryByKeysAsync(inventoryId, branchId, inventoryEntryTypeId))
    };

    const action = actionMap[buttonClick.target.id];
    if (!action) {
      await this.resetInventoryEntry(inventoryId, branchId, inventoryEntryTypeId);
      return;
    }

    try {
      const inventoryEntry = await action();
      this.inventoryEntryContract = inventoryEntry;
      this.inventoryEntryId = inventoryEntry.inventoryEntryId;
      await this.validateForm(inventoryEntry);
      this.location.replaceState(`/${this.url}/register/${this.inventoryEntryId}`);
    } catch (error) {
      this.handleInventoryEntryNotFound(inventoryId, branchId, inventoryEntryTypeId, 0);
      console.error(`Error al buscar la entrada de inventario (${buttonClick.target.id}).`, error);
    }
  }

  async getAllLists(
    ...listsToLoad: Array<'branches' | 'concepts' | 'inventories' | 'providers' | 'types'>
  ) {
    try {
      const lists = {
        branches: async () => {
          this.listBranches = await firstValueFrom(
            this.branchService.getAllBranchesForSelectAsync()
          );
        },
        concepts: async () => {
          this.listConcepts = await firstValueFrom(
            this.inventoryEntryService.getAllConceptsForSelect()
          );
        },
        inventories: async () => {
          this.listInventories = await firstValueFrom(
            this.inventoryEntryService.getAllInventoriesForSelect()
          );
        },
        providers: async () => {
          this.listProviders = await firstValueFrom(
            this.providerService.getAllProvidersForSelect()
          );
        },
        types: async () => {
          this.listTypes = await firstValueFrom(
            this.inventoryEntryService.getAllInventoryEntryTypesForSelect()
          );
        }
      };

      if (listsToLoad.length) {
        await Promise.all(listsToLoad.map(list => lists[list]()));
      } else {
        await Promise.all([
          lists.branches(),
          lists.concepts(),
          lists.inventories(),
          lists.providers(),
          lists.types()
        ]);
      }

      return true;
    } catch (error) {
      console.error('Error al obtener las listas.', error);
      return false;
    }
  }

  async getBranch(branchId: number | null, reload: boolean) {
    try {
      let validBranch = null;
      if (branchId != null) {
        const branch = await firstValueFrom(this.branchService.getBranchById(branchId));
        if (branch) {
          validBranch = branchId;
        }
      }
      this.branchId = validBranch ?? 0;
      this.formInventoryEntry.controls["branchId"].patchValue(validBranch);

      if (reload) {
        this.changeSelection();
      }
    } catch (error) {
      console.error('Error al buscar la sucursal.', error);
    }
  }

  getButtonClick(buttonClick: any) {
    let consecutive = this.formInventoryEntry.get("consecutive")?.value;
    const inventoryId = this.formInventoryEntry.get("inventoryId")?.value;
    const branchId = this.formInventoryEntry.get("branchId")?.value;
    const inventoryEntryTypeId = this.formInventoryEntry.get("inventoryEntryTypeId")?.value;

    if (branchId == null || branchId == 0) {
      this.toastHandlerService.showToast('warning', 'Seleccione una sucursal.');
      return;
    }

    consecutive = consecutive === 0 ? null : consecutive;
    this.handleInventoryEntryNavigation(buttonClick, inventoryId, branchId, inventoryEntryTypeId, consecutive);
  }

  async getConcept(conceptId: number | null) {
    const previousConceptId = this.inventoryEntryContract.conceptId;
    if (previousConceptId === conceptId) {
      this.setConceptId(conceptId);
      return;
    }

    try {
      let validConcept: number | null = null;
      if (conceptId !== null) {
        const concept = await firstValueFrom(this.inventoryEntryService.getConceptByIdForSelect(conceptId));
        if (concept) {
          validConcept = conceptId;
        }
      }

      if (this.quantityDetails !== 0) {
        const confirmed = await this.confirmDialogService.confirm(
          'La entrada tiene artículos asociados. ¿Realmente desea modificar el concepto?'
        );
        if (confirmed) {
          this.setConceptId(validConcept);
        } else {
          this.setConceptId(previousConceptId);
        }
      } else {
        this.setConceptId(validConcept);
      }
    } catch (error) {
      console.error('Error al buscar el concepto.', error);
    }
  }

  private setConceptId(value: number | null): void {
    this.formInventoryEntry.controls["conceptId"].patchValue(value);
    this.disabledDetail = true;
    this.disabledState = true;
  }

  async getFirstInventoryByCompanyAuthenticatedAsync() {
    try {
      const response = await firstValueFrom(this.inventoryService.getFirstInventoryByCompanyAuthenticatedAsync());
      this.inventoryId = response.inventoryId;
      await this.getInventory(response.inventoryId, false);
      await this.getFirstBranchByUserAuthenticatedAsync();
    } catch (error) {
      console.error('Error al buscar el primer inventario de la compañía.', error);
    }
  }

  async getFirstBranchByUserAuthenticatedAsync() {
    try {
      const response = await firstValueFrom(this.branchService.getFirstBranchByUserAuthenticatedAsync());
      this.branchId = response.branchId;
      this.getBranch(response.branchId, false);
      this.companyId = response.companyId;
    } catch (error) {
      console.error('Error al buscar la primera sucursal del usuario.', error);
    }
  }

  async getFormatByCompanyAndCode(): Promise<boolean> {
    try {
      if (this.formatModel.formatId == 0)
        this.formatModel = await firstValueFrom(this.formatService.getFormatByCompanyAndCode(this.companyId!, FormatsEnums.inventoryEntry));
      return true;
    } catch (error) {
      console.error('Error al buscar el formato de impresión.', error);
      return false;
    }
  }

  async getGeneralParametersByCompany() {
    const load = this.userAuthenticatedService.generalParameterObservable.subscribe(response => {
      this.swPurchaseModule = response.some(x => x.name === GeneralParameters.purchaseModule);
    });
    this.listObservers.push(load);
  }

  async getInventory(inventoryId: number | null, reload: boolean) {
    try {
      let validInventory = null;

      if (inventoryId != null) {
        const inventory = await firstValueFrom(this.inventoryService.getInventoryById(inventoryId));
        if (inventory) {
          validInventory = inventoryId;
        }
      }

      this.inventoryId = validInventory ?? 0;
      this.formInventoryEntry.controls["inventoryId"].patchValue(validInventory);

      if (reload) {
        this.changeSelection();
      }
    } catch (error) {
      console.error('Error al buscar el inventario.', error);
    }
  }

  async getInventoryEntryById() {
    try {
      this.inventoryEntryContract = await firstValueFrom(this.inventoryEntryService.getInventoryEntryById(this.inventoryEntryId));
      this.inventoryEntryId = this.inventoryEntryContract.inventoryEntryId;
    } catch (error) {
      console.error('Error al buscar la entrada de inventario.', error);
    }
  }

  async getPermission() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find(x => x === this.url);
      windowsOpened.push(this.url);
      localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      if (this.isOpened) {
        this.toastHandlerService.showToast(
          'warning',
          `No se permite tener dos ventanas/pestañas de ${this.nameWindow} abiertas.`
        );
      }
    } else {
      localStorage.clear();
    }

    Promise.all([
      this.getFirstBranchByUserAuthenticatedAsync(),
      this.getGeneralParametersByCompany()
    ]);

    try {
      this.permissionUpdatable = await firstValueFrom(this.windowService.getPermissionProfileByUrl(this.url));
      await this.getPermissionsForUserByWindow();

      await this.getAllLists();

    } catch (error) {
      console.error('Error al buscar los permisos del perfil.', error);
    }
  }

  async getPermissionsForUserByWindow() {
    try {
      this.userAuthenticated = await firstValueFrom(
        this.userAuthenticatedService.userObservable.pipe(
          filter(user => user && user.userId !== 0)
        )
      );
      this.permissionsUser = await firstValueFrom(this.optionWindowService.getPermissionsForUserByWindow(WindowEnums.InventoryEntry));
    } catch (error) {
      console.error('Error al buscar los permisos del usuario por ventana.', error);
    }
  }

  async getPrintInventoryEntrys(): Promise<boolean> {
    try {
      this.inventoryEntryPrintModel = await firstValueFrom(this.inventoryEntryService.getPrintInventoryEntry(this.inventoryEntryContract.inventoryEntryId));
      return true;
    } catch (error) {
      console.error('Error al buscar los datos de impresión de la entrada de inventario.', error);
      return false;
    }
  }

  async getProvider(providerId: number | null) {
    const previousProviderId = this.inventoryEntryContract.providerId;
    if (previousProviderId === providerId) {
      this.setProviderId(providerId);
      return;
    }

    if (this.quantityDetails !== 0 && this.inventoryEntryContract.inventoryEntryTypeId === InventoryEntryTypeEnums.devolution) {
      this.toastHandlerService.showToast(
        'warning',
        'En una devolución con detalle no se puede cambiar el proveedor.'
      );
      this.setProviderId(previousProviderId);
      return;
    }

    try {
      let validProvider: number | null = null;
      if (providerId !== null) {
        const provider = await firstValueFrom(this.providerService.getProviderByIdForSelect(providerId));
        if (provider) {
          validProvider = providerId;
        }
      }

      if (this.quantityDetails !== 0) {
        const confirmed = await this.confirmDialogService.confirm(
          'La entrada tiene artículos asociados. ¿Realmente desea modificar el proveedor?'
        );
        if (confirmed) {
          this.setProviderId(validProvider);
        } else {
          this.setProviderId(previousProviderId);
        }
      } else {
        this.setProviderId(validProvider);
      }
    } catch (error) {
      console.error('Error al buscar el proveedor.', error);
    }
  }

  async getPurchaseConceptForDefault() {
    try {
      const conceptId = await firstValueFrom(this.inventoryEntryService.getPurchaseConcept());
      this.getConcept(conceptId);
    } catch (error) {
      console.error('Error al buscar el concepto de compra por defecto.', error);
    }
  }

  private setProviderId(value: number | null): void {
    this.formInventoryEntry.controls["providerId"].patchValue(value);
    this.disabledDetail = true;
    this.disabledState = true;
  }

  getQuantityDetails(quantityDetails: number) {
    this.quantityDetails = quantityDetails;
    setTimeout(() => {
      const control = this.formInventoryEntry.controls["swRequirePurchaseOrder"];
      this.quantityDetails !== 0 ? control.disable() : control.enable();
    }, 100);
  }

  async printPage() {
    if (!this.validations()) return;

    if (this.quantityDetails == 0) {
      this.toastHandlerService.showToast(
        'warning',
        `No es posible imprimir la entrada de inventario, no tiene ningún detalle.`
      );
      return;
    }

    if (this.inventoryEntryContract.inventoryEntryStateId === InventoryEntryStateEnums.open) {
      this.toastHandlerService.showToast(
        'warning',
        `No es posible imprimir, la entrada de inventario se encuentra en estado abierto.`
      );
      return;
    }
    this.toastHandlerService.clearAllToasts();
    if (!await this.getFormatByCompanyAndCode()) return;
    if (!await this.getPrintInventoryEntrys()) return;
    this.finishLoadingPrint = false;
    await this.waitForComponenteImpresionToLoad();
  }

  async send() {
    if (this.disabledForm) {
      this.toastHandlerService.showToast(
        'warning',
        `No es posible guardar, la entrada de inventario NO se encuentra en estado abierto.`
      );
      return;
    }

    if (this.formInventoryEntry.valid) {
      const modelInventoryEntry = this.formInventoryEntry.getRawValue();

      //Hago null, los campos que permiten ser nulos:
      modelInventoryEntry.remission = modelInventoryEntry.remission || null;
      modelInventoryEntry.invoice = modelInventoryEntry.invoice || null;
      modelInventoryEntry.observation = modelInventoryEntry.observation || null;

      if (modelInventoryEntry.remission == null && modelInventoryEntry.invoice == null) {
        this.toastHandlerService.showToast(
          'warning',
          `Falta ingresar el numero de la remisión o el numero de la factura.`
        );
        return;
      }

      if (this.inventoryEntryId == 0) {
        try {
          const response = await firstValueFrom(this.inventoryEntryService.createInventoryEntry(modelInventoryEntry));
          this.toastHandlerService.showToast(
            'success',
            `La entrada de inventario fue creada exitosamente.`
          );
          this.inventoryEntryContract = response;
          this.inventoryEntryId = this.inventoryEntryContract.inventoryEntryId;
          await this.validateForm(this.inventoryEntryContract);
          this.location.replaceState(`/${this.url}/register/${this.inventoryEntryId}`);
        } catch (error) {
          console.error('Error al crear la entrada de inventario.', error);
        }
      } else {
        this.inventoryEntryContract.conceptId = modelInventoryEntry.conceptId;
        this.inventoryEntryContract.providerId = modelInventoryEntry.providerId;
        this.inventoryEntryContract.dateEntry = modelInventoryEntry.dateEntry;
        this.inventoryEntryContract.remission = modelInventoryEntry.remission;
        this.inventoryEntryContract.invoice = modelInventoryEntry.invoice;
        this.inventoryEntryContract.observation = modelInventoryEntry.observation;
        this.inventoryEntryContract.swRequirePurchaseOrder = modelInventoryEntry.swRequirePurchaseOrder;
        try {
          const response = await firstValueFrom(this.inventoryEntryService.updateInventoryEntry(this.inventoryEntryContract));
          this.toastHandlerService.showToast(
            'success',
            `La entrada de inventario fue modificada exitosamente.`
          );
          this.inventoryEntryContract = response;
          await this.validateForm(this.inventoryEntryContract);
        } catch (error) {
          console.error('Error al actualizar la entrada de inventario.', error);
        }
      }
    } else {
      this.showValidationMessages();
    }
  }

  showValidationMessages() {
    const controlMessages: any = {
      inventoryId: 'El campo inventario es obligatorio.',
      branchId: 'El campo sucursal es obligatorio.',
      inventoryEntryTypeId: 'El campo tipo de entrada es obligatorio.',
      conceptId: 'El campo concepto es obligatorio.',
      providerId: 'El campo proveedor es obligatorio.',
      dateEntry: 'El campo fecha de entrada es obligatorio.',
      remission: 'El campo remisión permite máximo 15 caracteres.',
      invoice: 'El campo factura permite máximo 15 caracteres.',
      observation: 'El campo observación permite máximo 250 caracteres.'
    };

    Object.keys(controlMessages).forEach(control => {
      if (this.formInventoryEntry.controls[control].invalid) {
        this.toastHandlerService.showToast(
          'warning',
          controlMessages[control]
        );
      }
    });
  }

  async resetInventoryEntry(inventoryId: number, branchId: number, inventoryEntryTypeId: number) {
    this.quantityDetails = 0;
    this.inventoryEntryId = 0;
    this.inventoryEntryContract = new InventoryEntryModel();
    this.inventoryEntryContract.inventoryId = inventoryId;
    this.inventoryEntryContract.branchId = branchId;
    this.inventoryEntryContract.inventoryEntryTypeId = inventoryEntryTypeId;
    this.inventoryEntryContract.inventoryEntryId = this.inventoryEntryId;
    await this.validateForm(this.inventoryEntryContract);
  }

  async updateFormState() {
    const stateConfig: any = {
      [InventoryEntryStateEnums.open]: {
        severity: 'danger',
        icon: 'pi pi-lock-open',
        title: 'Cerrar',
        text: 'Abierta',
        isDisabled: false,
        enableConsecutive: this.inventoryEntryId !== 0,
      },
      [InventoryEntryStateEnums.close]: {
        severity: 'success',
        icon: 'pi pi-lock',
        title: 'Abrir',
        text: 'Cerrada',
        isDisabled: true,
        enableConsecutive: true,
      },
    };

    const currentState = this.inventoryEntryContract.inventoryEntryStateId;
    const config = stateConfig[currentState];

    if (config) {
      this.severityState = config.severity;
      this.iconState = config.icon;
      this.titleState = config.title;
      this.stateText = config.text;
      this.disabledForm = config.isDisabled;
      this.disabledActions = config.isDisabled;
      this.disabledDetail = config.isDisabled;

      setTimeout(() => {
        config.isDisabled ? this.formInventoryEntry.disable() : this.formInventoryEntry.enable();
        const control = this.formInventoryEntry.controls["consecutive"];
        config.enableConsecutive ? control.enable() : control.disable();
      }, 100);
    }
    if (!this.permissionUpdatable) setTimeout(() => this.formInventoryEntry.disable(), 100);
    setTimeout(() => this.formInventoryEntry.controls["inventoryId"].enable(), 100);
    setTimeout(() => this.formInventoryEntry.controls["branchId"].enable(), 100);
    setTimeout(() => this.formInventoryEntry.controls["inventoryEntryTypeId"].enable(), 100);
    if (this.inventoryEntryTypeId == InventoryEntryTypeEnums.transfer) this.disabledForm = true;
  }

  validations() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast(
        'error',
        `El usuario no tiene permisos para modificar entradas de inventario. Comuníquese con el administrador del sistema.`
      );
      return false;
    }

    if (this.inventoryEntryContract.inventoryEntryId == 0) {
      this.toastHandlerService.showToast(
        'warning',
        `Debe crear el encabezado de la entrada de inventario.`
      );
      return false;
    }
    return true;
  }

  async validateForm(inventoryEntry: InventoryEntryModel) {
    this.formInventoryEntry = this.formBuilder.group({
      inventoryId: [inventoryEntry.inventoryId, [Validators.required, Validators.min(1)]],
      branchId: [inventoryEntry.branchId, [Validators.required, Validators.min(1)]],
      inventoryEntryTypeId: [inventoryEntry.inventoryEntryTypeId, [Validators.required, Validators.min(1)]],
      consecutive: [inventoryEntry.consecutive, []],
      conceptId: [inventoryEntry.conceptId, [Validators.required, Validators.min(1)]],
      providerId: [inventoryEntry.providerId, [Validators.required, Validators.min(1)]],
      dateEntry: [inventoryEntry.dateEntry ?
        this.dateConverterService.convertUtcToLocalDate(inventoryEntry.dateEntry) : null, [Validators.required]],
      remission: [inventoryEntry.remission, [Validators.maxLength(15)]],
      invoice: [inventoryEntry.invoice, [Validators.maxLength(15)]],
      observation: [inventoryEntry.observation, [Validators.maxLength(250)]],
      swRequirePurchaseOrder: [inventoryEntry.swRequirePurchaseOrder, []]
    });

    if (inventoryEntry.inventoryEntryId == 0) {
      if (this.mainBranchByUser.branchId != 0) this.getBranch(this.mainBranchByUser.branchId, false);
      await this.getPurchaseConceptForDefault();
      if (this.swPurchaseModule) this.formInventoryEntry.controls["swRequirePurchaseOrder"].patchValue(true);
    }
    this.updateFormState();
  }

  waitForComponenteImpresionToLoad(): Promise<void> {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise<void>(async (resolve) => {
      // Verifica si termino de cargar 
      if (this.finishLoadingPrint) {
        //Imprimimos el documento
        print();
        resolve();
      } else {
        // Si no, espera y vuelve a verificar
        setTimeout(() => this.waitForComponenteImpresionToLoad().then(resolve), 100);
      }
    });
  }
}
